import {
  GET_FILES,
  DELETE_FILES,
  DOWNLOAD_FILES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from './actionType';

const INIT_STATE = {
  files: null,
  download: null,
  error: {},
  success: null,
};

const Files = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_FILES:
          return {
            ...state,
            files: action.payload.data,
            success: null,
            error: {},
          };
        case DELETE_FILES:
          return {
            ...state,
            success: 'Successfully deleted proposal',
            error: {},
          };
        case DOWNLOAD_FILES:
          return {
            ...state,
            download: action.payload.data,
            success: 'Successfully downloaded proposal',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_FILES:
          return {
            ...state,
            success: null,
            files: null,
            error: action.payload.error,
          };
        case DELETE_FILES:
          return {
            ...state,
            success: null,
            error: action.payload.error,
          };
        case DOWNLOAD_FILES:
          return {
            ...state,
            success: null,
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    default:
      return { ...state };
  }
};

export default Files;
